module.exports = __webpack_public_path__ + "img/07 Auto-line.ee200eb6.png";